import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description: 'We’re legally required to ask you for a proof of address',
    editAddress: 'Edit address',
    isHostedLabel: 'I am hosted',
    isNotHostedLabel: 'I have a document in my name',
    next: 'Continue',
    proofOfAddressFileLabel: 'Proof of address',
    subTitleAddProofOfAddress: 'Add a proof of address',
    subTitleCheckAddress: 'Check your personal address',
    subTitleCheckProofOfAddress: 'Check your proof of address',
    title: 'Proof of address',
  },
  fr: {
    description:
      'La réglementation bancaire nous impose de vous demander un justificatif de domicile.',
    editAddress: 'Modifier l’adresse',
    isHostedLabel: 'Je suis hébergé·e',
    isNotHostedLabel: 'J’ai un document à mon nom',
    next: 'Continuer',
    proofOfAddressFileLabel: 'Justificatif de domicile',
    subTitleAddProofOfAddress: 'Ajouter un justificatif de domicile',
    subTitleCheckAddress: 'Vérifiez votre adresse personnelle',
    subTitleCheckProofOfAddress: 'Vérifiez votre justificatif de domicile',
    title: 'Justificatif de domicile',
  },
} as const);
